import React from "react";
import { stackList } from "../../data/ProjectData";
import {
  Image,
  Technologies,
  Tech,
  TechImg,
  TechName,
  ContactWrapper,
} from "./AboutElements";
import ScrollAnimation from "react-animate-on-scroll";
function About() {
  return (
    <ContactWrapper id="about">
      <div className="Container">
        <div className="SectionTitle">About Me</div>
        <div className="BigCard">
        <ScrollAnimation animateIn="fadeInLeft">
          <Image
            src="/man-svgrepo-com.svg"
            alt="man-svgrepo"
          />
        </ScrollAnimation>
          <div className="AboutBio">
            <ScrollAnimation animateIn="fadeInLeft">
           Hello! I'm <strong>Muhammad Zeshan</strong>, A Final Year Computer Science student at UMT Lahore and the Founder of Creationz, a digital services agency where I design and deploy client-focused web applications. Driven by a deep passion for problem-solving, my work spans building responsive web interfaces with React and Next.js, cross-platform mobile apps using React Native, and AI-powered workflow automations (like InboxIQ built with n8n and Gemini APIs).
            </ScrollAnimation>

            <br /><br />
            
            <ScrollAnimation animateIn="fadeInLeft">
            My journey into the world of technology began with a strong passion for problem-solving, which led me to pursue the Computer Systems Technology program.I specialize in building modern React/Next.js web apps, cross-platform React Native mobile solutions, and integrating AI automation workflows. As the founder of Creationz, I bridge the gap between UI design and production-ready code to solve real-world problems.
            </ScrollAnimation>
            <br /><br />
            <ScrollAnimation animateIn="fadeInLeft">
              Passionate about collaborative engineering, client satisfaction, and turning complex ideas into functional software products.
              <div className="tagline2">
                I have become confident using the following technologies:
              </div>
            </ScrollAnimation>
            

            <Technologies>
              {stackList.map((stack, index) => (
                <ScrollAnimation animateIn="fadeInLeft" key={index}>
                  <Tech key={index} className="tech">
                    <TechImg src={stack.img} alt={stack.name} />
                    <TechName>{stack.name}</TechName>
                  </Tech>
                </ScrollAnimation>
              ))}
            </Technologies>
          </div>

        </div>
      </div>
    </ContactWrapper>
  );
}

export default About;
